import { FilterSection } from 'Components/Filters';
import {
  SingleDateInput,
  SingleDateInputProps,
} from 'Components/Form/Inputs/DateInput';
import Label from 'Components/Form/Label';
export function DateFilter(
  props: SingleDateInputProps & {
    label: string;
  },
) {
  return (
    <FilterSection>
      <Label
        htmlFor="from"
        label={props.label}
        className="flex w-full justify-between items-center gap-2"
      >
        <SingleDateInput
          {...props}
          showIcon={true}
          border=""
          format="UTC"
          className="gap-2"
          clearable={false}
        />
      </Label>
    </FilterSection>
  );
}
